import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { handleSsoCallback } from '../../services/ssoService';

const SsoCallback = () => {
    const { databaseName } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const dbName = databaseName || sessionStorage.getItem('sso_database_name');

        if (!dbName) {
            setError('No database name found. Please try logging in again.');
            return;
        }

        handleSsoCallback(dbName)
            .then((result) => {
                sessionStorage.removeItem('sso_database_name');

                if (result.emailaddress && result.validationkey) {
                    navigate(`/${dbName}/${encodeURIComponent(result.emailaddress)}/${encodeURIComponent(result.validationkey)}`);
                } else {
                    setError('Authentication succeeded but no account details were returned.');
                }
            })
            .catch((err) => {
                console.error('SSO callback error:', err);
                setError(err.message || 'An error occurred during SSO authentication.');
            });
    }, [databaseName, navigate]);

    if (error) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                padding: '20px',
                textAlign: 'center',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '20px 30px',
                    borderRadius: '8px',
                    maxWidth: '500px',
                    width: '100%'
                }}>
                    <h3 style={{ marginTop: 0 }}>SSO Authentication Error</h3>
                    <p>{error}</p>
                    <a
                        href={`/${databaseName || ''}`}
                        style={{
                            display: 'inline-block',
                            marginTop: '10px',
                            padding: '8px 20px',
                            backgroundColor: '#721c24',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '4px'
                        }}
                    >
                        Back to Login
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div className="small-spinner" style={{ marginBottom: '20px' }}>
                <span></span><span></span><span></span><span></span>
            </div>
            <p>Completing sign-in, please wait...</p>
        </div>
    );
};

export default SsoCallback;
